module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_TH.7f5635d0.jpg";